// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="10" height="8"><path d="M4 8a1 1 0 01-.707-.293l-3-3a1 1 0 111.414-1.414l2.226 2.226L8.233.36a1 1 0 011.538 1.28l-5 6a1 1 0 01-.724.359z" fill="#51bb7b"/></svg>
);

export default fn;
